import { useEffect, useState } from 'react';

/**
 * El valor, atrasado. La contraparte de useDebounce, que atrasa una función.
 *
 * Existe porque atrasar la llamada no sirve cuando además hay un efecto mirando el
 * valor: el efecto corre igual en cada tecla y la llamada atrasada se suma encima, o
 * sea dos fetch por pulsación en vez de ninguno hasta que la persona deja de escribir.
 * Atrasando el valor, el efecto se entera una sola vez (review de #1792).
 */
export function useDebouncedValue<T>(value: T, delay: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
